import { render, staticRenderFns } from "./crm.vue?vue&type=template&id=50c8c896"
import script from "./crm.vue?vue&type=script&lang=js"
export * from "./crm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports